module.exports = __webpack_public_path__ + "media/images/logo-mobile-1b693f0da106a43db80f9493ed254d98.svg";